/**
 * An HTTP error status arrives here as Apollo's `ServerError`. Apollo Client 4 rejects with the network
 * error itself instead of `networkError`, so at the bump this one expression changes and no call site does.
 */
export const getNetworkError = (error) => {
    const networkError = error === null || error === void 0 ? void 0 : error.networkError;
    return networkError instanceof Error ? networkError : undefined;
};
